/* ck-custphotos.js — behavior for snippets/ck-customer-photos.liquid.
 *
 * <ck-custphotos> wraps a thumbnail strip and a native <dialog> lightbox.
 * The gallery payload is embedded JSON inside the element, and every query
 * is scoped to the element, so multiple instances stay independent. Native
 * <dialog> supplies focus trapping, Escape handling, and focus restore.
 *
 * This file and the snippet are one unit with a fixed markup contract
 * (dialog, [data-large], [data-position], [data-index], [data-gallery]).
 * The entry guard covers the legitimate empty states (no dialog, empty
 * gallery); beyond it there are deliberately no per-hook null checks — if
 * the snippet's markup changes without this file, failing loudly here is
 * the desired behavior.
 */
(() => {
  if (customElements.get('ck-custphotos')) return;

  class CkCustPhotos extends HTMLElement {
    connectedCallback() {
      
      if (this._ckReady) return;
      this._ckReady = true;

      this.dialog = this.querySelector('dialog');
      this.large = this.querySelector('[data-large]');
      this.counter = this.querySelector('[data-position]');
      try {
        this.gallery = JSON.parse(this.querySelector('[data-gallery]').textContent);
      } catch {
        this.gallery = [];
      }
      if (!this.dialog || this.gallery.length === 0) return;

      const single = this.gallery.length < 2;
      this.querySelector('[data-prev]').disabled = single;
      this.querySelector('[data-next]').disabled = single;

      
      this.addEventListener('click', (e) => {
        const thumb = e.target.closest('[data-index]');
        if (thumb) return this.open(Number(thumb.dataset.index));
        if (e.target.closest('[data-prev]')) return this.show(this.index - 1);
        if (e.target.closest('[data-next]')) return this.show(this.index + 1);
        if (e.target.closest('[data-close]') || e.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.show(this.index - 1);
        if (e.key === 'ArrowRight') this.show(this.index + 1);
      });
    }

    open(index) {
      this.show(index);
      this.dialog.showModal();
    }

    
    show(index) {
      const n = this.gallery.length;
      this.index = ((index % n) + n) % n;
      const photo = this.gallery[this.index];
      this.large.src = photo.url;
      this.large.alt = photo.alt;
      this.counter.textContent = `Photo ${this.index + 1} of ${n}`;
      if (n > 1) {
        new Image().src = this.gallery[(this.index + 1) % n].url;
        new Image().src = this.gallery[(this.index + n - 1) % n].url;
      }
    }
  }

  customElements.define('ck-custphotos', CkCustPhotos);
})();
